import { AnalyzedErrorList } from "../options";
export const getErrorMsg = (data: any) => {
  if (!data.categoryId) {
    return AnalyzedErrorList.find((i) => i.label === "media")?.value;
  } else if (data.duplicateWithLeadnos) {
    return AnalyzedErrorList.find(
      (i) => i.label === "member-duplicate"
    )?.value.replace("XXXX", data.duplicateWithLeadnos.join().toString());
  } else if (data.duplicateWithIndex || data.duplicateWithIndex === 0) {
    return AnalyzedErrorList.find(
      (i) => i.label === "row-duplicate"
    )?.value.replace("N", (data.duplicateWithIndex + 2).toString());
  } else if (data.isInvalidCompanyNumber) {
    return AnalyzedErrorList.find((i) => i.label === "companyNumber")?.value;
  } else if (data.isInvalidLead) {
    return AnalyzedErrorList.find((i) => i.label === "no-kid")?.value;
  } else if (data.isTestData) {
    return AnalyzedErrorList.find((i) => i.label === "test")?.value;
  } else {
    return "Something went wrong! Fail to create CL.";
  }
};
